import styled from "styled-components"

export const OptionCard = ({title, description, icon, onChange, selected}) => {


    return (
        <StyledOptionCard
            className={selected ? 'isSelected' : null}
            onClick={onChange}
        >
            <div className="optionCardIcon">
                {icon}
            </div>
            <div className="optionCardContent">
                <div className="optionCardTitle">
                    {title}
                </div>
                <div className="optionCardDescription">
                    {description}
                </div>
            </div>
        </StyledOptionCard>
    )
}

const StyledOptionCard = styled.div`
    display: flex;
    gap: ${({theme}) => theme.spacing.lg};
    cursor: pointer;
    transition-duration: 220ms;

    div.optionCardIcon
    {
        height: 38px;
        width: 38px;
        flex-shrink: 0;
        background: ${({theme}) => theme.colors.mutedForeground};
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({theme}) => theme.colors.neutralPrimaryBackground};
        font-weight: 600;
        transition-duration: 220ms;

        svg
        {
            fill: ${({theme}) => theme.colors.neutralPrimaryBackground};
        }
    }

    div.optionCardContent
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
        color: ${({theme}) => theme.colors.mutedForeground};
        transition-duration: 220ms;

        div.optionCardTitle
        {
            font-weight: 600;
        }
    }

    &.isSelected
    {
        div.optionCardIcon
        {
            background: ${({theme}) => theme.colors.accentForeground};
        }

        div.optionCardContent
        {
            color: ${({theme}) => theme.colors.neutralPrimaryForeground};
        }


    }
`

